import { z } from 'zod';

/**
 * @remarks
 * since we need to localize error messages, we pass translation keys
 * from the validation schema and the form-error.messages file will map the keys
 * to localized error messages.
 */

const optionalString = z.string().trim().optional();
const requiredString = z
  .string()
  .trim()
  .min(1, 'payment.form.validation.required');

const requiredAlphabets = requiredString.regex(/^(\p{Letter}| )+$/u, {
  message: 'payment.form.validation.invalid.chars',
});

export const addressSchema = z.object({
  firstName: requiredAlphabets,
  lastName: requiredAlphabets,
  address: requiredString,
  unit: optionalString,
  city: requiredString,
  country: requiredString,
  /**
   * @remarks
   * state can be optionally required depending on the country,
   * so we store state in either state(not required) or stateCode(required)
   * for countries with no states, we store it in state
   * for countries with states, we store it in stateCode
   */
  state: optionalString,
  stateCode: requiredString,
  postalCode: optionalString,
});
